// Generated by node scripts/generate-file-sizes.cjs. Do not edit manually.
import file4 from "../assets/Leadership_pdf/cmdprofilepdf.pdf";
import file5 from "../assets/achievements/monthly_progress_reports/Apr 2023.pdf";
import file6 from "../assets/achievements/monthly_progress_reports/Apr 2025.pdf";
import file7 from "../assets/achievements/monthly_progress_reports/Apr 2026.pdf";
import file8 from "../assets/achievements/monthly_progress_reports/Aug 2023.pdf";
import file9 from "../assets/achievements/monthly_progress_reports/Aug 2024.pdf";
import file10 from "../assets/achievements/monthly_progress_reports/Aug 2026.PDF";
import file11 from "../assets/achievements/monthly_progress_reports/Dec 2025.pdf";
import file12 from "../assets/achievements/monthly_progress_reports/Feb 2025.pdf";
import file13 from "../assets/achievements/monthly_progress_reports/Feb 2026.pdf";
import file14 from "../assets/achievements/monthly_progress_reports/JULY 2026.PDF";
import file15 from "../assets/achievements/monthly_progress_reports/Jan 2024.pdf";
import file16 from "../assets/achievements/monthly_progress_reports/Jan 2025.pdf";
import file17 from "../assets/achievements/monthly_progress_reports/Jan 2026.pdf";
import file18 from "../assets/achievements/monthly_progress_reports/July 2023.pdf";
import file19 from "../assets/achievements/monthly_progress_reports/July 2024.pdf";
import file20 from "../assets/achievements/monthly_progress_reports/Jun 2024.pdf";
import file21 from "../assets/achievements/monthly_progress_reports/June 2023.pdf";
import file22 from "../assets/achievements/monthly_progress_reports/June 2025.pdf";
import file23 from "../assets/achievements/monthly_progress_reports/MPR JUNE.PDF";
import file24 from "../assets/achievements/monthly_progress_reports/MPR MAY.PDF";
import file25 from "../assets/achievements/monthly_progress_reports/MPR SEPTEMBER.PDF";
import file26 from "../assets/achievements/monthly_progress_reports/Mar 2023.pdf";
import file27 from "../assets/achievements/monthly_progress_reports/Mar 2026.pdf";
import file28 from "../assets/achievements/monthly_progress_reports/May 2023.pdf";
import file29 from "../assets/achievements/monthly_progress_reports/May 2025.pdf";
import file30 from "../assets/achievements/monthly_progress_reports/Nov 2024.pdf";
import file31 from "../assets/achievements/monthly_progress_reports/Nov 2025.pdf";
import file32 from "../assets/achievements/monthly_progress_reports/Oct 2023.pdf";
import file33 from "../assets/achievements/monthly_progress_reports/Oct 2024.pdf";
import file34 from "../assets/achievements/monthly_progress_reports/Oct 2025.pdf";
import file35 from "../assets/achievements/monthly_progress_reports/Sep 2023.pdf";
import file36 from "../assets/achievements/monthly_progress_reports/Sep 2024.pdf";
import file37 from "../assets/achievements/monthly_progress_reports/Sep 2025.pdf";
import file38 from "../assets/achievements/overall_achivements/Overall Achievments.pdf";
import file39 from "../assets/achievements/population_wise_comulative_disburesement/Population wise Comulative Disburesement.pdf";
import file40 from "../assets/achievements/state _wise_achievement/State Wise Achievement.pdf";
import file41 from "../assets/achievements/year_wIse_disburesment_details/1994-95.pdf";
import file42 from "../assets/achievements/year_wIse_disburesment_details/1995-96.pdf";
import file43 from "../assets/achievements/year_wIse_disburesment_details/1996-97.pdf";
import file44 from "../assets/achievements/year_wIse_disburesment_details/1997-98.pdf";
import file45 from "../assets/achievements/year_wIse_disburesment_details/1998-99.pdf";
import file46 from "../assets/achievements/year_wIse_disburesment_details/1999-00.pdf";
import file47 from "../assets/achievements/year_wIse_disburesment_details/2000-01.pdf";
import file48 from "../assets/achievements/year_wIse_disburesment_details/2001-02.pdf";
import file49 from "../assets/achievements/year_wIse_disburesment_details/2002-03.pdf";
import file50 from "../assets/achievements/year_wIse_disburesment_details/2003-04.pdf";
import file51 from "../assets/achievements/year_wIse_disburesment_details/2004-05.pdf";
import file52 from "../assets/achievements/year_wIse_disburesment_details/2005-06.pdf";
import file53 from "../assets/achievements/year_wIse_disburesment_details/2006-07.pdf";
import file54 from "../assets/achievements/year_wIse_disburesment_details/2007-08.pdf";
import file55 from "../assets/achievements/year_wIse_disburesment_details/2008-09.pdf";
import file56 from "../assets/achievements/year_wIse_disburesment_details/2009-10.pdf";
import file57 from "../assets/achievements/year_wIse_disburesment_details/2010-11.pdf";
import file58 from "../assets/achievements/year_wIse_disburesment_details/2011-12.pdf";
import file59 from "../assets/achievements/year_wIse_disburesment_details/2012-13.pdf";
import file60 from "../assets/achievements/year_wIse_disburesment_details/2013-14.pdf";
import file61 from "../assets/achievements/year_wIse_disburesment_details/2014-15.pdf";
import file62 from "../assets/achievements/year_wIse_disburesment_details/2015-16.pdf";
import file63 from "../assets/achievements/year_wIse_disburesment_details/2016-17.pdf";
import file64 from "../assets/achievements/year_wIse_disburesment_details/2017-18.pdf";
import file65 from "../assets/achievements/year_wIse_disburesment_details/2018-19.pdf";
import file66 from "../assets/achievements/year_wIse_disburesment_details/2019-20.pdf";
import file67 from "../assets/achievements/year_wIse_disburesment_details/2020-21.pdf";
import file68 from "../assets/achievements/year_wIse_disburesment_details/2021-22.pdf";
import file69 from "../assets/achievements/year_wIse_disburesment_details/2022-23.pdf";
import file70 from "../assets/achievements/year_wIse_disburesment_details/2023-2024.pdf";
import file71 from "../assets/achievements/year_wIse_disburesment_details/2024-25.pdf";
import file72 from "../assets/achievements/year_wIse_disburesment_details/2025-26.pdf";
import file73 from "../assets/achievements/year_wIse_disburesment_details/2026-27.pdf";
import file74 from "../assets/achievements/year_wise_achivement/Year Wise Achivement.pdf";
import file75 from "../assets/career_pdf/87OPEN TENDER FOR SELECTION.pdf";
import file76 from "../assets/career_pdf/AM-Finpdf-71a8313df8e3a2ef09958395dc0f6836.pdf";
import file77 from "../assets/career_pdf/AM-HRMpdf-ae8cee30d08b047ad8815c3d4907542a.pdf";
import file78 from "../assets/career_pdf/AM-PLRpdf-3fca5f41588a95ea6a6e95eacbc03396.pdf";
import file79 from "../assets/career_pdf/AM-Result-pdf-baa6887c73f81dd63a2b61abe5fec2cd.pdf";
import file80 from "../assets/career_pdf/AMFAcctpdf-fd7da7d59784edfa0bedb7894243aff2.pdf";
import file81 from "../assets/career_pdf/AMHRMpdf-5c0109aeac723f945b8f5fd2e94e7b6f.pdf";
import file82 from "../assets/career_pdf/AMProjectCoordpdf-d4adbdb6473c759f18606d0388fe794c.pdf";
import file83 from "../assets/career_pdf/CSpdf-d63b44dec48c90eb5d0be8cde49f3c4b.pdf";
import file84 from "../assets/career_pdf/Corrigendum 2.pdf";
import file85 from "../assets/career_pdf/Corrigendum of tender for Redesigning and Maintenance of the Official Website of NMDFC.pdf";
import file86 from "../assets/career_pdf/Corrigendum of tender for empanelment of Event Management Agencies (EMA).pdf";
import file87 from "../assets/career_pdf/EA-Resultpdf-e1c42c7590924542dc8249503f09de90.pdf";
import file88 from "../assets/career_pdf/EMPANELMENT OF EVENT MANAGEMENT AGENCIES-EMAs.pdf";
import file89 from "../assets/career_pdf/FAQ 31.07.2026.pdf";
import file90 from "../assets/career_pdf/FAQ-FINALpdf-fd0709dda41b44f18057e80b5ab30960.pdf";
import file91 from "../assets/career_pdf/NMDFCInternshipSchemePDF-f254d6290c851de5899533dc2338dfe3.pdf";
import file92 from "../assets/career_pdf/Notice inviting tenders for conducting Socio Economic Impact Study of beneficiaries financed under various schemes of NMDFC.pdf";
import file93 from "../assets/career_pdf/Proposal for Kaushal se Kushalta Scheme.pdf";
import file94 from "../assets/career_pdf/Redesigning and Maintenance of the Official Website of NMDFC for One Year.pdf";
import file95 from "../assets/career_pdf/Test-resultscorepdf-a816ce79e5364ec5100a6a43e9c812c7.pdf";
import file96 from "../assets/career_pdf/UpdatedResultDeclarationofExamconductedon28092025DirectRecruitmentBasisPDF-734d41d528eab26406cf232c1a3abbcf.pdf";
import file97 from "../assets/career_pdf/YPpdf-d646317c0d2af7a6cf5e0dfee83ed44d.pdf";
import file98 from "../assets/career_pdf/consultant-MFpdf-aa22f42012e2a775e26589266f70e91e.pdf";
import file99 from "../assets/docs/Bihar-Finance-Rules-2005-english 2.pdf";
import file100 from "../assets/docs/Compilation_of_amendments_in_GFR_2017_English_upto_31_12_2023_Final 2.pdf";
import file101 from "../assets/docs/Privacy Policy.pdf";
import file102 from "../assets/docs/Term of Use.pdf";
import file103 from "../assets/docs/Three Cover MoF_2022_curve_works.cdr.pdf";
import file104 from "../assets/policy_pdf/Content Archival (CAP) policy.pdf";
import file105 from "../assets/policy_pdf/Content Contribution, Moderation and Approval (CMAP) policy.pdf";
import file106 from "../assets/policy_pdf/Content Review (CRP) policy.pdf";
import file107 from "../assets/policy_pdf/Contingency Management plan.pdf";
import file108 from "../assets/policy_pdf/Copyright Policy.pdf";
import file109 from "../assets/policy_pdf/Hyperlinking Policy.pdf";
import file110 from "../assets/policy_pdf/Privacy Policy.pdf";
import file111 from "../assets/policy_pdf/Security Policy.pdf";
import file112 from "../assets/policy_pdf/Terms & Conditions.pdf";
import file113 from "../assets/policy_pdf/Website monitoring plan.pdf";
import file114 from "../assets/rti_pdf/Budget-2024-25pdf-311abaa56a3792f4afe9e61db2fe4837.pdf";
import file115 from "../assets/rti_pdf/CMD-taxi-contractpdf-37ed077aa90b36ba151a209dee8a6f78.pdf";
import file116 from "../assets/rti_pdf/Cahpter-14pdf-1954558807afd6bf8d17b0525082460c.pdf";
import file117 from "../assets/rti_pdf/Chapter-11pdf-baf3d6c4c0e60702834e436b4b1eb10e.pdf (1).pdf";
import file118 from "../assets/rti_pdf/Chapter-15pdf-a59d505b21418df2b748293c9642ee73.pdf";
import file119 from "../assets/rti_pdf/Chapter-16pdf-2aeeb829e908a5c43a02d1ec1c90b325.pdf";
import file120 from "../assets/rti_pdf/Chapter-17pdf-091d8a6ea08a275120b8f0945b083efc.pdf";
import file121 from "../assets/rti_pdf/Chapter-3pdf-5f36e86af91edbb859ac72c4d61afd88.pdf";
import file122 from "../assets/rti_pdf/Chapter-4transfer-orders-and-work-allocationpdf-f2a4c4438b42534621eb8e4b3ccb5015.pdf";
import file123 from "../assets/rti_pdf/Chapter-8pdf-229e4fb3519a377c787adaf21d3b5674.pdf";
import file124 from "../assets/rti_pdf/Corporate-Secreteriatepdf-b31a60cb9488f87e62d1785322557876.pdf";
import file125 from "../assets/rti_pdf/DPDPpdf-dc545c1d257d6bbde166be4b4c1e83b7.pdf";
import file126 from "../assets/rti_pdf/HindiBillText-DigitalPersonalDataProtectionBill2023pdf-a1f182071a160f081823e0dbd62702f9.pdf";
import file127 from "../assets/rti_pdf/NMDFCBrochureEnglish-FINA4pdf-300e8786e726d4984b8b74c7e00e03c4.pdf";
import file128 from "../assets/rti_pdf/RTI--Chapter-1pdf-600ded739f0efbf9e4dafaee45aa4156.pdf";
import file129 from "../assets/rti_pdf/RTIEnglishpdf-01d308b80efbcaaee8b045ede7e9ee6b.pdf";
import file130 from "../assets/rti_pdf/RTIHindipdf-73d6591db2191174be992dcab3f64b4b.pdf";
import file131 from "../assets/rti_pdf/RTIRules2019Hindipdf-fd3062d313bf157b32667756426a911a.pdf";
import file132 from "../assets/rti_pdf/RTIlatestupdarationpdf-e4bd624fcd002eb6ec0bf35f286cd327.pdf";
import file133 from "../assets/rti_pdf/RecruitmentRulesPDF-36b79fd0d26433a7b7dfc35585171d5b.pdf";
import file134 from "../assets/rti_pdf/RuleBookCompendiumwithoutpdf-c4ec5c612724c86ae2a78f34e9bcbf25.pdf";
import file135 from "../assets/rti_pdf/Security-contractpdf-fdbf2ac27f499c2db035f0fd68586979.pdf";
import file136 from "../assets/rti_pdf/SummaryReportNationalMinoritiesDevelopmentandFinanceCorporation2023-24pdf-9e9cf77f2755247f51e912ef403fa9a9.pdf";
import file137 from "../assets/rti_pdf/SummaryReportNationalMinoritiesDevelopmentandFinanceCorporation2024-251pdf-c77f3f1fce14b87fb2f722d998fe3ba7.pdf";
import file138 from "../assets/rti_pdf/TADARulesPDF-d24af052e82fd169f705c8854a670b50.pdf";
import file139 from "../assets/rti_pdf/TAReport2021_22PDF-7f115ee72f842377767c54a9d13bc802.pdf";
import file140 from "../assets/rti_pdf/Tour_A-DA-Details-of-CMDpdf-7e260dbe9854002bdf17b8a4c8d4acfd.pdf";
import file141 from "../assets/rti_pdf/Transparency-Audit-ReportNMDFC-2022-23pdf-ded145b559805bb347745adb089d2f92.pdf";
import file142 from "../assets/rti_pdf/amendedRulesPDF-127657efc987da1d73c9313d8179eac2.pdf";
import file143 from "../assets/rti_pdf/brochurehindi-FINApdf-f07c08fcd8ccd1a30cabde2372f1c10b.pdf";
import file144 from "../assets/rti_pdf/chap-6-reg6d543cce-ffd1-4ca1-9010-e1610a958f8dpdf-e267c755448a6213477255deee0dc68e.pdf";
import file145 from "../assets/rti_pdf/chapter-9--redba1ffefa-d902-43c6-b540-50c37a51ea33pdf-aa7530045c2f22ad6f73ba84cf9fa6f0.pdf";
import file146 from "../assets/rti_pdf/chapter5---redegafd4ef23-94e2-4590-bc62-cc5eee823349pdf-8f73b88d3a9d825846c800887d5bb8f4.pdf";
import file147 from "../assets/rti_pdf/chatper_7_bodpdf-b64d6ec8b7775994fdd387eb1044f4bd.pdf";
import file148 from "../assets/rti_pdf/lok_sabha_pdf/2009-2010pdf-61c62920330eb1d7769530118271b107.pdf";
import file149 from "../assets/rti_pdf/lok_sabha_pdf/2010-2011pdf-eb294fed405830fb0c0b6b041a48c00c.pdf";
import file150 from "../assets/rti_pdf/lok_sabha_pdf/2011-2012pdf-2546b9562f5768ff53a6252f837c8cda.pdf";
import file151 from "../assets/rti_pdf/lok_sabha_pdf/2012-2013pdf-d43f15b6f94f7387df17dfb5a0032ce1.pdf";
import file152 from "../assets/rti_pdf/lok_sabha_pdf/2013-2014-pdf-69a9dfd0ffe5f27a3d7ee5b531cd7fd9.pdf";
import file153 from "../assets/rti_pdf/lok_sabha_pdf/2014-2015-pdf-0130dde0113db8555aecd0cc358f890b.pdf";
import file154 from "../assets/rti_pdf/lok_sabha_pdf/2020-2021pdf-f799cb63d15b6c6ad11cfdfe63df19c1.pdf";
import file155 from "../assets/rti_pdf/lok_sabha_pdf/2021-2022pdf-c88058e16db1efad4f254fedf0a0292a.pdf";
import file156 from "../assets/rti_pdf/lok_sabha_pdf/L - 2024-25.pdf";
import file157 from "../assets/rti_pdf/lok_sabha_pdf/L-2015-16pdf-2e11f5fea531dba29f67eff8c323e408.pdf";
import file158 from "../assets/rti_pdf/lok_sabha_pdf/L-2016-17pdf-5bc0e0c536e3cca911db55d1748a4d98.pdf";
import file159 from "../assets/rti_pdf/lok_sabha_pdf/L-2017-18pdf-b2ca2cce194dcc6a972265724be9334f.pdf";
import file160 from "../assets/rti_pdf/lok_sabha_pdf/L-2018-2019-PDF-fbdd4be87c618d69a8fb7fcb27eed218.pdf";
import file161 from "../assets/rti_pdf/lok_sabha_pdf/L-2019-20-up-to-JulyPDF-17059782a587afa573bb0ff0956cceba.pdf";
import file162 from "../assets/rti_pdf/lok_sabha_pdf/L-2019-20-up-to-Macrh-20PDF-74f800e49c6c1e5412be3c77af9aa312.pdf";
import file163 from "../assets/rti_pdf/lok_sabha_pdf/LSQ_2024_2025compressedpdf-094f0d2e2e273703448d0f04cb6bf21e.pdf";
import file164 from "../assets/rti_pdf/lok_sabha_pdf/Lok-Sabha-2022-23cpdf-6057e3cb4fb4a4f0517e37ed79cf0a33.pdf";
import file165 from "../assets/rti_pdf/lok_sabha_pdf/Lok-Sabha_2023_2024PDF-96864346e6faa93837c2c022d512e454.pdf";
import file166 from "../assets/rti_pdf/lok_sabha_pdf/Parliament Question 2019-20.pdf";
import file167 from "../assets/rti_pdf/lok_sabha_pdf/Parliament Question 2020-21.pdf";
import file168 from "../assets/rti_pdf/manpower-contractpdf-cc4219673f11abacc3a4b113cec8f18f.pdf";
import file169 from "../assets/rti_pdf/rajya_sabha_pdf/2009-10pdf-469db2a01b72e28779ecf291669ae95e.pdf";
import file170 from "../assets/rti_pdf/rajya_sabha_pdf/2010-11pdf-3513fb854c6cf6aa8cf71357b0d3dc70.pdf";
import file171 from "../assets/rti_pdf/rajya_sabha_pdf/2010-2011pdf-eb294fed405830fb0c0b6b041a48c00c.pdf";
import file172 from "../assets/rti_pdf/rajya_sabha_pdf/2011-2012pdf-2546b9562f5768ff53a6252f837c8cda.pdf";
import file173 from "../assets/rti_pdf/rajya_sabha_pdf/2012-13pdf-20bf67b950dd7927205837023ce2ca6e.pdf";
import file174 from "../assets/rti_pdf/rajya_sabha_pdf/2013-14pdf-b11349448b5d1814cf05bec9f2a5d8bf (1).pdf";
import file175 from "../assets/rti_pdf/rajya_sabha_pdf/2013-14pdf-b11349448b5d1814cf05bec9f2a5d8bf.pdf";
import file176 from "../assets/rti_pdf/rajya_sabha_pdf/2014-15-pdf-eaa4227b5bdd82c83ec46f9d9a768314.pdf";
import file177 from "../assets/rti_pdf/rajya_sabha_pdf/R--2020-21pdf-6ee7209476980dbfdc60077dd4905bef.pdf";
import file178 from "../assets/rti_pdf/rajya_sabha_pdf/R-2015-16-pdf-a79a73bfe582d6902525b06529576de9.pdf";
import file179 from "../assets/rti_pdf/rajya_sabha_pdf/R-2016-17pdf-5c6c1038218db3465b1794d383fe65ae.pdf";
import file180 from "../assets/rti_pdf/rajya_sabha_pdf/R-2017-18pdf-a18d21548d03a749f29c24af32adb69d.pdf";
import file181 from "../assets/rti_pdf/rajya_sabha_pdf/R-2018-19PDF-f626d3f55ec961a0eb245539ca60d2be.pdf";
import file182 from "../assets/rti_pdf/rajya_sabha_pdf/R-2019-20-up-to-JulyPDF-14de216d552f624791cb30e64a20af4a.pdf";
import file183 from "../assets/rti_pdf/rajya_sabha_pdf/R-2019-20-up-to-Macrh-20PDF-1c3d51c82a7fdab3a1eb902b626e5cf1.pdf";
import file184 from "../assets/rti_pdf/rajya_sabha_pdf/RAJAYA-SABH_2021_2022A60be6pdf-336e2c9ecbf0294ca0cefa82a19d014b.pdf";
import file185 from "../assets/rti_pdf/rajya_sabha_pdf/RS_2024_2025Qcompressedpdf-192f08856e3134c4e5bd954c4369bcfb.pdf";
import file186 from "../assets/rti_pdf/rajya_sabha_pdf/Rajya-Sabha-2022-23PDF-58965847039d3550649ce0568ece528a.pdf";
import file187 from "../assets/rti_pdf/rajya_sabha_pdf/Rajya-Sabha_2023_2024PDF-dd26fa0d2dc1b8c73e174222b2294576.pdf";
import file188 from "../assets/rti_pdf/tranAudita_2020_2021_pdf-8a6518a9c3d6b3cc8bd40d407ae00d97 (1).pdf";
import file189 from "../assets/rti_pdf/tranAuditapdf-8a6518a9c3d6b3cc8bd40d407ae00d97.pdf";
import file190 from "../assets/tenders/01 Dec,2023 03-40 PM to 12 Dec,2023 03-39 PM.pdf";
import file191 from "../assets/tenders/01 Jan,2021 12-00 AM to 01 Apr,2021 12-00 AM.pdf";
import file192 from "../assets/tenders/03 May,2022 12-00 AM to 18 May,2022 12-00 AM.pdf";
import file193 from "../assets/tenders/04 Jan,2024 05-35 PM to 15 Jan,2024 04-00 PM (1).pdf";
import file194 from "../assets/tenders/04 Jan,2024 05-35 PM to 15 Jan,2024 04-00 PM.pdf";
import file195 from "../assets/tenders/06 Sep,2023 12-00 AM to 22 Sep,2023 12-00 AM.pdf";
import file196 from "../assets/tenders/07 Jan,2021 12-00 AM to 27 Jan,2021 12-00 AM.pdf";
import file197 from "../assets/tenders/07 Mar,2025 to 17 Mar,2025 .pdf";
import file198 from "../assets/tenders/07 Oct,2023 12-00 AM to 10 Oct,2023 12-00 AM.pdf";
import file199 from "../assets/tenders/08 Sep,2025 to 23 Sep,2025 .pdf";
import file200 from "../assets/tenders/09 Jan,2024 to 17 Jan,2024 02-00 PM.pdf";
import file201 from "../assets/tenders/14 Jun,2022 12-00 AM to 29 Jun,2022 12-00 AM.pdf";
import file202 from "../assets/tenders/15 Jan,2021 12-00 AM to 22 Jan,2021 12-00 AM.pdf";
import file203 from "../assets/tenders/15 Jun,2023 12-00 AM to 03 Jul,2023 12-00 AM.pdf";
import file204 from "../assets/tenders/16 Jun,2022 12-00 AM to 27 Jun,2022 12-00 AM.pdf";
import file205 from "../assets/tenders/16 Oct,2025 to 27 Oct,2025 .pdf";
import file206 from "../assets/tenders/16 Sep,2022 12-00 AM to 21 Jul,2022 12-00 AM (1).pdf";
import file207 from "../assets/tenders/16 Sep,2022 12-00 AM to 21 Jul,2022 12-00 AM.pdf";
import file208 from "../assets/tenders/17 Aug,2022 12-00 AM to 30 Aug,2022 12-00 AM (1).pdf";
import file209 from "../assets/tenders/17 Aug,2022 12-00 AM to 30 Aug,2022 12-00 AM.pdf";
import file210 from "../assets/tenders/17 Feb,2022 12-00 AM to 23 Feb,2022 12-00 AM (1).pdf";
import file211 from "../assets/tenders/17 Feb,2022 12-00 AM to 23 Feb,2022 12-00 AM.pdf";
import file212 from "../assets/tenders/18 Aug,2022 12-00 AM 25 Aug,2022 12-00 AMs (1).pdf";
import file213 from "../assets/tenders/18 Aug,2022 12-00 AM 25 Aug,2022 12-00 AMs.pdf";
import file214 from "../assets/tenders/18 Aug,2022 12-00 AM to 25 Aug,2022 12-00 AM (1).pdf";
import file215 from "../assets/tenders/18 Aug,2022 12-00 AM to 25 Aug,2022 12-00 AM.pdf";
import file216 from "../assets/tenders/18 Jul,2025 to 07 Aug,2025 .pdf";
import file217 from "../assets/tenders/18 Oct,2021 12-00 AM to 25 Oct,2021 12-00 AM.pdf";
import file218 from "../assets/tenders/19 Sep,2025 to 07 Oct,2025 .pdf";
import file219 from "../assets/tenders/20 Mar,2025 to 24 Mar,2025 .pdf";
import file220 from "../assets/tenders/20 May,2025 to 03 Jun,2025 .pdf";
import file221 from "../assets/tenders/25 Jan,2024 to 06 Feb,2024 .pdf";
import file222 from "../assets/tenders/26 Apr,2022 12-00 AM to 09 May,2022 12-00 AM.pdf";
import file223 from "../assets/tenders/26 Feb,2022 12-00 AM to 02 Mar,2022 12-00 AM.pdf";
import file224 from "../assets/tenders/29 Aug,2025 to 16 Sep,2025 .pdf";
import file225 from "../assets/tenders/30 Jul,2025 to 14 Aug,2025 .pdf";
import file226 from "../assets/tenders/30 May,2025 to 04 Jun,2025 .pdf";
import file227 from "../assets/tenders/31 May,2022 12-00 AM to 15 Jun,2022 12-00 AM.pdf";
import file228 from "../assets/tenders/RFP for CCPD Audit 2026.pdf";
import file229 from "../assets/tenders/resource/Lending_policyEnglishNo13-09-2022CTPpdf-85842b6d8098aa6793a83f4aba51178f.pdf";
import file230 from "../assets/tenders/resource/MGT-7-Form-2023-24pdf-cd55896a0f1be940d9d014141dc88535.pdf";
import file231 from "../assets/tenders/resource/Minority_Concentrated_Blocks_1228-MCB-Blockpdf-30c692c76198e4f76249db9f0276cd9b.pdf";
import file232 from "../assets/tenders/resource/Minority_Concentrated_Districts_MCD-Distirictpdf-9708bdb5b703097416347f17d5eb94a4.pdf";
import file233 from "../assets/tenders/resource/RISK_MANAGEMENT_POLICY_OF_NMDFC.pdf";
import file234 from "../assets/tenders/resource/annual_reports/Annual Report 2012-13.pdf";
import file235 from "../assets/tenders/resource/annual_reports/Annual Report 2013-14.pdf";
import file236 from "../assets/tenders/resource/annual_reports/Annual Report 2014-15.pdf";
import file237 from "../assets/tenders/resource/annual_reports/Annual Report 2016-17.pdf";
import file238 from "../assets/tenders/resource/annual_reports/Annual Report 2017-18.pdf";
import file239 from "../assets/tenders/resource/annual_reports/Annual Report 2018-19.pdf";
import file240 from "../assets/tenders/resource/annual_reports/Annual Report 2019-20.pdf";
import file241 from "../assets/tenders/resource/annual_reports/Annual Report 2020-21.pdf";
import file242 from "../assets/tenders/resource/annual_reports/Annual Report 2021-22.pdf";
import file243 from "../assets/tenders/resource/annual_reports/Annual Report 2022-23.pdf";
import file244 from "../assets/tenders/resource/annual_reports/Annual Report 2023-24.pdf";
import file245 from "../assets/tenders/resource/annual_reports/Annual Report 2024-25.pdf";
import file246 from "../assets/tenders/resource/catalogue.pdf";
import file247 from "../assets/tenders/resource/csr/CSRpdf-ccb7c0c4c3fe81f0ef91c404e6414b20.pdf";
import file248 from "../assets/tenders/resource/csr/NMDFC-CSR-Policy-Sept-2023pdf-36413685cfd5fbc35c1b2734773ece04.pdf";
import file249 from "../assets/tenders/resource/csr/csrpdf-1da99427b694750d3848627fc8811d98.pdf";
import file250 from "../assets/tenders/resource/impact_evaluation_study/Impact Evaluation Study for the beneficiaries financed under Term Loan and Micro Finance schemes of NMDFC during 2011-12.pdf";
import file251 from "../assets/tenders/resource/impact_evaluation_study/Impact Study Report 2021 conducted by MDI.pdf";
import file252 from "../assets/tenders/resource/impact_evaluation_study/NMDFC - Socio economic impact study (Report-2023).pdf";
import file253 from "../assets/tenders/resource/impact_evaluation_study/Report 1 of Benefs. financed FY 2014-16.pdf";
import file254 from "../assets/tenders/resource/impact_evaluation_study/Report on Assessment of Impact of NMDFC Programmes Financed through NGOs.pdf";
import file255 from "../assets/tenders/resource/impact_evaluation_study/Report2 of Benefs. financed FY 2014-16.pdf";
import file256 from "../assets/tenders/resource/impact_evaluation_study/Verification of Benificiary of Credit based schemes 2013-14.pdf";
import file257 from "../assets/tenders/resource/impact_evaluation_study/Verification of beneficiaries financed under Term Loan and Micro Finance schemes of NMDFC during 2012-13.pdf";
import file258 from "../assets/tenders/resource/ksr_project/AISECT_Ahamadab5pdf-87fb73f8e9a38699ad282262dff8684d.pdf";
import file259 from "../assets/tenders/resource/ksr_project/CFTI_1_Tamilnadupdf-66c1c905621de9c331d877f549a4d0df.pdf";
import file260 from "../assets/tenders/resource/ksr_project/Jai_Bharav_Rajsthan4pdf-5b771f074884080274d28e4e930d4528.pdf";
import file261 from "../assets/tenders/resource/ksr_project/Manav_Vikash_Rajsthan3pdf-7bae8eb64e507e92e321d32f30d9431d.pdf";
import file262 from "../assets/tenders/resource/ksr_project/NSIC_RAJPURA6PDF-e033fc8ee898db7899470454df37ccbb.pdf";
import file263 from "../assets/tenders/resource/ksr_project/Thruvallur2pdf-29ac595318d5e919ac43ea7537864a51.pdf";
import file264 from "../assets/tenders/resource/resource_Documents/Education Loan.pdf";
import file265 from "../assets/tenders/resource/resource_Documents/Format of Government Guarantee Deed.pdf";
import file266 from "../assets/tenders/resource/resource_Documents/General Loan Agreement Format.pdf";
import file267 from "../assets/tenders/resource/resource_Documents/Guidelines for Implementation of Micro Financing Schemes of NMDFC.pdf";
import file268 from "../assets/tenders/resource/resource_Documents/Memorandum of Association.pdf";
import file269 from "../assets/tenders/resource/resource_Documents/Micro Loan.pdf";
import file270 from "../assets/tenders/resource/resource_Documents/One Time Settlement Scheme.pdf";
import file271 from "../assets/tenders/resource/resource_Documents/Policy on Training for Board Members.pdf";
import file272 from "../assets/tenders/resource/resource_Documents/Scheme for Writing Off of Loans.pdf";
import file273 from "../assets/tenders/resource/resource_Documents/Term Loan.pdf";
import file274 from "../assets/tenders/resource/resource_Documents/memorandum_of_Understanding/MOU  2017-2018.pdf";
import file275 from "../assets/tenders/resource/resource_Documents/memorandum_of_Understanding/MOU  2018-2019.pdf";
import file276 from "../assets/tenders/resource/resource_Documents/memorandum_of_Understanding/MOU  2019-2020.pdf";
import file277 from "../assets/tenders/resource/resource_Documents/memorandum_of_Understanding/MOU 2010-2011.pdf";
import file278 from "../assets/tenders/resource/resource_Documents/memorandum_of_Understanding/MOU 2012-2013.pdf";
import file279 from "../assets/tenders/resource/resource_Documents/memorandum_of_Understanding/MOU 2013-2014.pdf";
import file280 from "../assets/tenders/resource/resource_Documents/memorandum_of_Understanding/MOU 2014-2015.pdf";
import file281 from "../assets/tenders/resource/resource_Documents/memorandum_of_Understanding/MOU 2015-2016.pdf";
import file282 from "../assets/tenders/resource/resource_Documents/memorandum_of_Understanding/MOU 2016-2017.pdf";
import file283 from "../assets/tenders/resource/resource_Documents/memorandum_of_Understanding/MOU 2020-2021.pdf";
import file284 from "../assets/tenders/resource/resource_Documents/memorandum_of_Understanding/MOU 2021-2022.pdf";
import file285 from "../assets/update_folder/Act_2013.pdf";
import file286 from "../assets/update_folder/DTS_MOE.pdf";
import file287 from "../assets/update_folder/FinaLAM-Result-pdf-baa6887c73f81dd63a2b61abe5fec2cd.pdf";
import file288 from "../assets/update_folder/MANF-OM-DT02022024pdf-f28008820c6157f2a78e6469443f4545.pdf";
import file289 from "../assets/update_folder/MANF_Aadharlinkpdf-59ec4c0832ce10a16d6eba76a8d6d747.pdf";
import file290 from "../assets/update_folder/noticepdf-ead74eceb221cb167747d80dbfbc48ee.pdf";
import file291 from "../assets/updates_pdf/Advertisementpdf.pdf";
import file292 from "../assets/updates_pdf/RecruitentApplication.pdf";
import file293 from "../assets/updates_pdf/RecruitmentAdvertisement.pdf";

export default new Map([
  ["/tenders/appointment-of-audit-firms-corrigendum-1.pdf", 1469670],
  ["/tenders/hiring-consultant-marketing-finance.pdf", 309270],
  ["/tenders/manpower-outsourcing-services.pdf", 4215379],
  ["/tenders/rfp-transactional-advisor-corrigendum.pdf", 4215379],
  [file4, 432572],
  [file5, 5160663],
  [file6, 2987187],
  [file7, 1227248],
  [file8, 3277157],
  [file9, 395889],
  [file10, 1099238],
  [file11, 2513189],
  [file12, 2745900],
  [file13, 1251893],
  [file14, 1291684],
  [file15, 3198783],
  [file16, 1448558],
  [file17, 2513189],
  [file18, 3327770],
  [file19, 3198783],
  [file20, 431017],
  [file21, 3297309],
  [file22, 548551],
  [file23, 1299173],
  [file24, 1166019],
  [file25, 1280726],
  [file26, 7170994],
  [file27, 1372986],
  [file28, 3887487],
  [file29, 429819],
  [file30, 3094373],
  [file31, 1361585],
  [file32, 3695245],
  [file33, 3337057],
  [file34, 1930345],
  [file35, 3784828],
  [file36, 3411975],
  [file37, 2359685],
  [file38, 559923],
  [file39, 470401],
  [file40, 782213],
  [file41, 31152],
  [file42, 31066],
  [file43, 31387],
  [file44, 31928],
  [file45, 36173],
  [file46, 35096],
  [file47, 34501],
  [file48, 36040],
  [file49, 37306],
  [file50, 35653],
  [file51, 38442],
  [file52, 36141],
  [file53, 36122],
  [file54, 39446],
  [file55, 44287],
  [file56, 46481],
  [file57, 34695],
  [file58, 33515],
  [file59, 36048],
  [file60, 33148],
  [file61, 36421],
  [file62, 34857],
  [file63, 35727],
  [file64, 34993],
  [file65, 35009],
  [file66, 237696],
  [file67, 56133],
  [file68, 415102],
  [file69, 422501],
  [file70, 427463],
  [file71, 437204],
  [file72, 631158],
  [file73, 575305],
  [file74, 775560],
  [file75, 1412098],
  [file76, 404970],
  [file77, 415099],
  [file78, 419563],
  [file79, 406325],
  [file80, 152215],
  [file81, 154168],
  [file82, 154770],
  [file83, 152105],
  [file84, 209143],
  [file85, 96309],
  [file86, 663452],
  [file87, 463658],
  [file88, 686147],
  [file89, 1451379],
  [file90, 409527],
  [file91, 125654],
  [file92, 1764685],
  [file93, 819406],
  [file94, 479385],
  [file95, 880053],
  [file96, 651050],
  [file97, 890407],
  [file98, 4891775],
  [file99, 309270],
  [file100, 1469670],
  [file101, 163010],
  [file102, 169564],
  [file103, 4215379],
  [file104, 183448],
  [file105, 244337],
  [file106, 236380],
  [file107, 168936],
  [file108, 171276],
  [file109, 170594],
  [file110, 162165],
  [file111, 161943],
  [file112, 168818],
  [file113, 164598],
  [file114, 1121875],
  [file115, 83459],
  [file116, 396991],
  [file117, 550152],
  [file118, 409781],
  [file119, 502726],
  [file120, 415584],
  [file121, 734734],
  [file122, 1616678],
  [file123, 597033],
  [file124, 360331],
  [file125, 182082],
  [file126, 4450899],
  [file127, 3797755],
  [file128, 1305942],
  [file129, 355456],
  [file130, 681372],
  [file131, 398472],
  [file132, 355325],
  [file133, 3827030],
  [file134, 1933806],
  [file135, 131315],
  [file136, 225058],
  [file137, 269171],
  [file138, 314979],
  [file139, 548396],
  [file140, 409461],
  [file141, 212392],
  [file142, 4064596],
  [file143, 3714656],
  [file144, 388428],
  [file145, 190739],
  [file146, 297818],
  [file147, 212035],
  [file148, 774182],
  [file149, 392663],
  [file150, 904415],
  [file151, 970323],
  [file152, 895028],
  [file153, 1149905],
  [file154, 392663],
  [file155, 774182],
  [file156, 7403399],
  [file157, 756571],
  [file158, 964525],
  [file159, 1718157],
  [file160, 1517546],
  [file161, 620952],
  [file162, 2509267],
  [file163, 546925],
  [file164, 2938500],
  [file165, 10050467],
  [file166, 8823543],
  [file167, 6062007],
  [file168, 131925],
  [file169, 738271],
  [file170, 723628],
  [file171, 392663],
  [file172, 904415],
  [file173, 797501],
  [file174, 681309],
  [file175, 681309],
  [file176, 786974],
  [file177, 442352],
  [file178, 179975],
  [file179, 606053],
  [file180, 243339],
  [file181, 432715],
  [file182, 160639],
  [file183, 243003],
  [file184, 399619],
  [file185, 477538],
  [file186, 1267688],
  [file187, 4071402],
  [file188, 79492],
  [file189, 79492],
  [file190, 386732],
  [file191, 419372],
  [file192, 1008210],
  [file193, 332834],
  [file194, 332834],
  [file195, 2046712],
  [file196, 500554],
  [file197, 928889],
  [file198, 1028286],
  [file199, 84870],
  [file200, 2646816],
  [file201, 603962],
  [file202, 1078107],
  [file203, 1979629],
  [file204, 3555220],
  [file205, 11665],
  [file206, 44716],
  [file207, 44716],
  [file208, 479104],
  [file209, 479104],
  [file210, 1191401],
  [file211, 1191401],
  [file212, 717579],
  [file213, 717579],
  [file214, 717579],
  [file215, 717579],
  [file216, 1334401],
  [file217, 798249],
  [file218, 97487],
  [file219, 1042496],
  [file220, 96012],
  [file221, 319422],
  [file222, 935650],
  [file223, 725378],
  [file224, 101543],
  [file225, 586744],
  [file226, 547974],
  [file227, 1700761],
  [file228, 452510],
  [file229, 1181126],
  [file230, 1011207],
  [file231, 465321],
  [file232, 49417],
  [file233, 12784852],
  [file234, 27689414],
  [file235, 33180527],
  [file236, 3709517],
  [file237, 9306038],
  [file238, 1035911],
  [file239, 6073958],
  [file240, 4497508],
  [file241, 2433529],
  [file242, 6614591],
  [file243, 5827983],
  [file244, 4715373],
  [file245, 4602752],
  [file246, 33149138],
  [file247, 3497728],
  [file248, 1465224],
  [file249, 435453],
  [file250, 1311669],
  [file251, 1432840],
  [file252, 4350518],
  [file253, 4166501],
  [file254, 502800],
  [file255, 282738],
  [file256, 2636497],
  [file257, 2636497],
  [file258, 239928],
  [file259, 775012],
  [file260, 1095061],
  [file261, 540195],
  [file262, 220072],
  [file263, 556964],
  [file264, 94146],
  [file265, 1869265],
  [file266, 129008],
  [file267, 4491013],
  [file268, 1869265],
  [file269, 95210],
  [file270, 416942],
  [file271, 173365],
  [file272, 385610],
  [file273, 175743],
  [file274, 1619359],
  [file275, 1302209],
  [file276, 343413],
  [file277, 7543362],
  [file278, 9385562],
  [file279, 5939272],
  [file280, 4428050],
  [file281, 1655504],
  [file282, 1740815],
  [file283, 3280674],
  [file284, 2684115],
  [file285, 943714],
  [file286, 943714],
  [file287, 406325],
  [file288, 208369],
  [file289, 965029],
  [file290, 905386],
  [file291, 709007],
  [file292, 230203],
  [file293, 1569110],
]);
